import React from "react";
import Navbar from "../../Menu/Navbar";
import Preloader from "../../../Components/Preloader";
import PageHeader from "../../../Components/layouts/PageHeader";
import Footer from "../Sections/Footer";
import JobsCard from "./JobsCard";
import { useTranslation } from "react-i18next";

const Jobs = () => {
  const { t } = useTranslation();
  return (
    <>
      <Navbar type="internal" />
      <Preloader />
      <main className="main">
        <PageHeader
          current={t("jobs.jobs")}
          banner="/assets/imgs/page-header/banner5.png"
          link="jobs"
        />
        <JobsCard />
      </main>
      <Footer type="external" />
    </>
  );
};

export default Jobs;
